// extracted by mini-css-extract-plugin
export default {"loaderWrap":"Loader_loaderWrap__qkD+x","loaderWrapHeading":"Loader_loaderWrapHeading__sB6kj"};